export interface TimeSelectOption {
  value: string
  label: string
}

export const HOURS_OPTIONS: TimeSelectOption[] = Array.from({ length: 24 }, (_, i) => ({
  value: i.toString().padStart(2, '0'),
  label: i.toString().padStart(2, '0'),
}))

export const HOURS_12_OPTIONS: TimeSelectOption[] = Array.from({ length: 13 }, (_, i) => ({
  value: i.toString().padStart(2, '0'),
  label: i.toString().padStart(2, '0'),
}))

export const MINUTES_OPTIONS: TimeSelectOption[] = Array.from({ length: 60 }, (_, i) => ({
  value: i.toString().padStart(2, '0'),
  label: i.toString().padStart(2, '0'),
}))

export const SECONDS_OPTIONS: TimeSelectOption[] = Array.from({ length: 60 }, (_, i) => ({
  value: i.toString().padStart(2, '0'),
  label: i.toString().padStart(2, '0'),
}))

export const PERIODS_OPTIONS: TimeSelectOption[] = [
  { value: 'AM', label: 'AM' },
  { value: 'PM', label: 'PM' },
]

export const TAG_OPTIONS = [
  { label: 'Firm', value: 'fixed' },
  { label: 'Estimated', value: 'flexible' },
]